import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

import { UserService } from 'src/app/services/user.service';
import { formatDate } from '@angular/common';
import { EmailService } from 'src/app/services/email.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styles: [
  ]
})
export class EditUserComponent implements OnInit {

  public user = this.userService.selectedUser;
  public password;
  public demoDays = 1;

  public registerForm = this.fb.group({
    name: [this.user.name, Validators.required],
    surname: [this.user.surname, Validators.required],
    alias: [this.user.alias, Validators.required],
    email: [this.user.email, Validators.email],
    role: [this.user.role, Validators.required],
    phone:[this.user.phone],
    profession:[this.user.profession],
    company:[this.user.company],
    notes:[this.user.notes],
    remainingTests:[this.user.remainingTests],
    country:[this.user.country],
    city:[this.user.city],
    sex:[this.user.sex],
    firstBuy:[this.user.firstBuy],
    birthDate:[formatDate(this.user.birthDate, 'yyyy-MM-dd', 'en')],
    isCustomBrand: [this.user.isCustomBrand],
    canUseTestCreator: [this.user.canUseTestCreator],
    canUseCustomTests: [this.user.canUseCustomTests],
    isEnterprise: [this.user.isEnterprise],
    isUnlimited: [this.user.isUnlimited],
    subaccountLimit: [this.user.subaccountLimit],
    enterpriseExpireDate: [this.user.enterpriseExpireDate ? formatDate(this.user.enterpriseExpireDate, 'yyyy-MM-dd', 'en') : null],

  });

  constructor( private userService: UserService, private fb: FormBuilder, private emailService:EmailService, private router:Router) {
    if (!this.userService.selectedUser){
      this.router.navigateByUrl('/dashboard');
    }
  }

  ngOnInit(): void {
    if (!this.user){
      this.router.navigateByUrl('/dashboard');
    }
    if(this.user.role=='evaluated'){
      this.password = this.user.password
    }
  }

  update(){
    this.userService.updateUser(this.registerForm.value).subscribe(
      resp=>{
        Swal.fire('Usuario actualizado',"", 'success');
      },
      err=>console.log(err)
    )
  }

  updatePassword(){

    this.userService.updateUser({email:this.user.email, password: this.password}).subscribe(
      resp=>{
        var data = {
          email:this.user.email,
          password:this.password
        }
        this.emailService.changePassword(data).subscribe();
        Swal.fire("Contraseña actualizada");

        this.password = "";
      },
      err=>console.log(err)
    )
    
  }

  resetRemainingDays(){
    this.userService.updateUser({email:this.user.email, lastPurchase:Date.now(), firstBuy:true}).subscribe(
      resp=>{
        Swal.fire("Actualizado");
      },
      err=>console.log(err)
    )
  }

  clearBrand(){
    Swal.fire({
      icon: 'warning',
      text: '¿Estás seguro que quieres eliminar la marca personalizada?',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then(
      sel => {
        if (sel.isConfirmed){
          this.userService.updateUser({email:this.user.email, logoUrl:'', customColor: '', logoLink: ''}).subscribe(
            resp=>{
              Swal.fire("Actualizado");
            },
            err=>console.log(err)
          )
        }
      }
    )
  }

  public add370Days(date: string){
    let newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 365);
    return newDate;
  }

  setDemoDays(){
    let demoSubscriptionEnd = new Date();
    demoSubscriptionEnd.setDate(demoSubscriptionEnd.getDate() + this.demoDays);
    this.userService.updateUser({email:this.user.email, demoSubscriptionEnd:demoSubscriptionEnd, demoSubscription: true}).subscribe(
      resp=>{
        this.user = resp;
        Swal.fire("Actualizado");
      },
      err=>console.log(err)
    )
  }
}
